import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { FormikProps } from 'formik'
import { Card } from 'primereact/card'
import { Messages } from 'primereact/messages'

import { PanelContainer } from '../../../../../components/Panel'
import { EmailChips } from '../../../../settings/EmailForm/EmailChips'
import { EditSupplierFormDto } from '../../data'
import { SupplierFormFieldName } from '../Supplier.data'

type Props = {
  formik: FormikProps<EditSupplierFormDto>
  separator: string
  isFormFieldInvalid: (name: SupplierFormFieldName) => boolean
  wrongSupportEmails: string[] | null
  getFormErrorMessage: (name: SupplierFormFieldName) => JSX.Element
  isEdit: boolean
  isRequestRunning: boolean
  isLoading: boolean
}
export const PrimaryContact: React.FC<Props> = ({
  formik,
  separator,
  isFormFieldInvalid,
  wrongSupportEmails,
  getFormErrorMessage,
  isEdit,
  isRequestRunning,
  isLoading,
}) => {
  const { t } = useTranslation()
  const panelId = 'supplier-email'
  const messagesRef = useRef<Messages>(null)

  useEffect(() => {
    if (messagesRef.current) {
      if (isEdit) {
        messagesRef.current.clear()
        messagesRef.current.show({
          id: '1',
          sticky: true,
          severity: 'info',
          detail: t('settings.email.notifications.message'),
          closable: false,
        })
      } else {
        messagesRef.current.clear()
      }
    }
  }, [isEdit])

  return (
    <PanelContainer
      header={t('supplier.primaryContact.title')}
      id={panelId}
      toggleable={false}
    >
      <div className="grid">
        <div className="col-12 lg:col-4">
          <p>{t('supplier.primaryContact.subtitle')}</p>
        </div>
        <div className="col-12 lg:col-7 lg:col-offset-1">
          <Card className="md:px-4">
            <Messages ref={messagesRef} />

            {/* PrimaryContact */}
            <EmailChips
              id="supportValue"
              label={t('supplier.primaryContact.form.primaryContact.label')}
              value={formik.values.supportValue}
              separator={separator}
              formik={formik}
              isInvalid={isFormFieldInvalid('supportValue')}
              errorMessage={getFormErrorMessage('supportValue')}
              wrongEmails={wrongSupportEmails}
              disabled={!isEdit || isRequestRunning}
              isLoading={isLoading}
            />
          </Card>
        </div>
      </div>
    </PanelContainer>
  )
}
